import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Box, CircularProgress, Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { actionButtonStyles } from '../../styles/actionButton'; // Reuse your actionButtonStyles
import { textFieldStyles } from '../../styles/textFieldStyles'; // Reuse your textFieldStyles

const ResetPassword = () => {
  const { t } = useTranslation(['forms', 'buttons', 'messages']);
  const { token } = useParams(); // Get the token from the URL
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('Token from URL:', token);
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `http://localhost:5000/api/reset-password/reset-password/${token}`,
        { newPassword }
      );
      setMessage(response.data); // 'Password has been reset'
      setTimeout(() => navigate('/login'), 3000); // Redirect to login after success
    } catch (err) {
      setError(err.response?.data || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Box
        elevation={3}
        sx={{
          padding: 4,
          backgroundColor: 'white',
          boxShadow: '0px 4px 16px rgba(0,0,0,0.1)',
          border: 'none',
          borderRadius: 0,
        }}
      >
        {/* Logo Image */}
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
          <img src="/lp-logo.png" alt="Logo" style={{ width: '200px' }} />
        </Box>

        {/* <Typography variant="h4" align="center" sx={{ marginBottom: 2 }}>
          Reset Password
        </Typography> */}

        {message && <Alert severity="success" sx={{ marginBottom: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ marginBottom: 2 }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="newPassword"
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            size="small"
            sx={{ ...textFieldStyles(), marginBottom: 2 }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            id="confirmPassword"
            label="Confirm Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            size="small"
            sx={{ ...textFieldStyles(), marginBottom: 2 }}
          />

          <Button
            type="submit"
            fullWidth
            sx={actionButtonStyles()}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Reset Password'}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default ResetPassword;
